import { TWhiteLabelStore } from '../white-label.model';
import { resolveNavItemPanelToggleIcon } from './resolve-nav-item-panel-toggle-icon';

const PANEL_TOGGLE_ICON_PROPERTY = '--nav-item-toggle-icon-color';

export function clearNavItemPanelToggleIcon(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.removeProperty(PANEL_TOGGLE_ICON_PROPERTY);
}

export function setNavItemPanelToggleIcon(
  themeWrapper: HTMLBodyElement,
  whiteLabel: TWhiteLabelStore,
): void {
  const color = resolveNavItemPanelToggleIcon(whiteLabel.data);

  if (!color) {
    clearNavItemPanelToggleIcon(themeWrapper);
    return;
  }

  themeWrapper.style.setProperty(PANEL_TOGGLE_ICON_PROPERTY, color);
}
